import { platformMyAccess } from '@krp/platform-ui'

import { useAppSelector } from '../../app/hooks'

const selectMyAccess = platformMyAccess.select()

/**
 * Мои права (`access/me/capabilities`) для окон Platform: подписка и результат
 * из общего кэша. Кнопки по ним только ОТРАЖАЮТ сервер — команду он проверит сам.
 */
export function useMyAccess() {
  platformMyAccess.useQuerySubscription()
  return useAppSelector(selectMyAccess)
}
